import { observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'

export class SessionStore {
  @observable sessionID: string = uuidv4()
}
